module.exports = __webpack_public_path__ + "img/timing-box-es.f8cddf9a.png";